<template>
  <h1>admin</h1>
</template>

<script>
export default {};
</script>

<style></style>
